// extracted by mini-css-extract-plugin
module.exports = {"login-and-register":"Authenticator_style_login-and-register__32TyD","remember-check":"Authenticator_style_remember-check__9BLZT","main-logo":"Authenticator_style_main-logo__2qTMB"};